import { Link } from "react-router-dom";
import HomeServices from "../components/HomeServices";
function Home() {
    return (
     <>
     <main className="main">

{/* <!-- Hero Section --> */}
<section id="hero" className="hero section">

  <div id="hero-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">

    <div className="carousel-item active">
      <img src="assets/img/hero-carousel/hero-carousel-1.jpg" alt=""/>
      <div className="carousel-container">
        <h2>Welcome to <span>Sanjay Prasad & Associates !</span></h2>
        <p>CA Sanjay Prasad & Associates is a trusted chartered accountancy firm committed to delivering expert financial, auditing, taxation, and business advisory services. Led by CA Sanjay Prasad, the firm combines deep industry knowledge with personalized attention to help individuals, startups, and established businesses navigate complex financial landscapes with confidence and clarity.</p>
        <Link to="/aboutus" className="btn-get-started">Get Started</Link>
      </div>
    </div>
    {/* <!-- End Carousel Item --> */}

    <div className="carousel-item">
      <img src="assets/img/hero-carousel/hero-carousel-2.jpg" alt=""/>
      <div className="carousel-container">
        <h2>Who We Are ?</h2>
        <p>CA Sanjay Prasad & Associates is a professionally managed chartered accountancy firm dedicated to providing reliable, efficient, and ethical financial solutions. With a client-focused approach and deep expertise in accounting, tax, audit, and compliance, we serve individuals and businesses with integrity and precision.</p>
        <Link to="/aboutus" className="btn-get-started">Get Started</Link>
      </div>
    </div>
    {/* <!-- End Carousel Item --> */}

    <div className="carousel-item">
      <img src="assets/img/hero-carousel/hero-carousel-3.jpg" alt=""/>
      <div className="carousel-container">
        <h2>Why Sanjay prasad & Associates ?</h2>
        <p>At CA Sanjay Prasad & Associates, we blend professional expertise with personalized service to deliver practical financial solutions. Clients choose us for our integrity, timely support, and deep understanding of tax laws, compliance, and business strategy. We focus on building long-term relationships based on trust, transparency, and results.</p>
        <a href="/aboutus" className="btn-get-started">Get Started</a>
      </div>
    </div>
    {/* <!-- End Carousel Item --> */}

    <a className="carousel-control-prev" href="#hero-carousel" role="button" data-bs-slide="prev">
      <span className="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true"></span>
    </a>

    <a className="carousel-control-next" href="#hero-carousel" role="button" data-bs-slide="next">
      <span className="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true"></span>
    </a>

  </div>
</section>
{/* <!-- /Hero Section --> */}


{/* <!-- About Section --> */}
<section id="about" className="section about">

  <div className="container" data-aos="fade-up" data-aos-delay="100">

    <div className="row gy-4">
      <div className="col-lg-6 order-1 order-lg-2">
        <img src="assets/img/about.jpg" className="img-fluid" alt=""/>
      </div>
      <div className="col-lg-6 order-2 order-lg-1 content">
        <h3>WHO WE ARE ?</h3>
        <p className="fst-italic">
        At CA Sanjay Prasad & Associates, we are a team of experienced professionals dedicated to providing comprehensive financial and business solutions. With expertise in accounting, taxation, auditing, and corporate advisory, we focus on helping businesses and individuals navigate complex financial landscapes with integrity and precision.
        </p>
        <h3>About Us </h3>
        <p className="fst-italic">
        CA Sanjay Prasad & Associates is a trusted chartered accountancy firm offering expert services in accounting, taxation, auditing, and corporate advisory. With a client-focused approach, we deliver tailored financial solutions, helping businesses and individuals achieve success through professional guidance and reliable support.
        </p>
        <h3>Our Vission </h3>
        <p className="fst-italic">
        To be a leading provider of innovative financial solutions, empowering businesses and individuals with the knowledge and expertise to achieve sustainable growth, financial clarity, and success.
        </p>
        <h3>Our Mission </h3>
        <p className="fst-italic">
        To deliver exceptional financial services with integrity, professionalism, and personalized attention, helping our clients navigate financial challenges and achieve their goals with confidence and clarity.
        </p>
      </div>
    </div>

  </div>

</section>
{/* <!-- /About Section --> */}

{/* <!-- Services Section --> */}
     <HomeServices />

{/* <!-- /Services Section --> */}

{/* <!-- Clients Section --> */}
<section id="clients" className="section clients">
  {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2>Our Clients</h2>
    <p>
      We serve a diverse range of clients, including individuals, startups, SMEs, and large corporations across multiple industries. Our client relationships are built on trust, confidentiality, and a commitment to delivering timely, value-driven financial solutions.
    </p>
  </div>

  {/* Clients Carousel */}
  <div className="container" data-aos="fade-up" data-aos-delay="100">
    <div className="swiper init-swiper">
      <div className="swiper-wrapper align-items-center">
        {[
          "client-1.png",
          "client-2.png",
          "client-3.png",
          "client-4.png",
          "client-5.png",
          "client-6.png",
          "client-7.png",
          "client-8.png",
        ].map((client, index) => (
          <div className="swiper-slide" key={index}>
            <img
              src={`assets/img/clients/${client}`}
              className="img-fluid"
              alt={`Client ${index + 1}`}
            />
          </div>
        ))}
      </div>
      <div className="swiper-pagination"></div>
    </div>
  </div>
</section>

{/* <!-- /Clients Section --> */}

</main>

     </>
    );
  }   
  export default Home;